import * as React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Icon } from "src/components/icons/Icon";
import Page from "src/components/common/Page";
import PageHero from "src/components/common/PageHero";
import neurapulseLogo from "src/assets/images/neurapulse/neurapulse-logo-icon-blue.png";
import styles from "./DatasetListView.module.css";
import DatasetAPI from "src/admin/Organization/Datasets/DatasetAPI";
import DatasetContext from "src/context/DatasetContext";
import clsx from "clsx";

interface IProps {
	match?: any;
}
interface IOrganizationDatasetsState {
	datasetList: DatasetDTO[];
	filtered: any[];
	customFields: CustomFieldDTO[];
}

class DatasetListView extends React.Component<
	IProps,
	IOrganizationDatasetsState
> {
	_isMounted = false;

	public constructor(props: any) {
		super(props);
		this.state = {
			datasetList: [],
			filtered: [],
			customFields: [],
		};
	}

	public componentDidMount() {
		this._isMounted = true;

		const organizationId = this.props.match.params.organizationId;

		DatasetAPI.getClientSiteOrganizationDatasets(
			organizationId,
			"userCount"
		).then((data) => {
			if (this._isMounted) {
				this.setState({ datasetList: data });
			}
		});
	}

	public componentWillUnmount() {
		this._isMounted = false;
	}

	public render() {
		const { datasetList } = this.state;
		const organizationId = this.props.match.params.organizationId;

		return (
			<Page title="Select a dataset">
				<PageHero>
					<h1 className="mb-0 text-center">Select a Dataset</h1>
				</PageHero>
				<div className="container-fluid">
					<div className="row">
						<div className="col-md-6 col-lg-4 col-xl-3 mx-auto">
							<div className="list-group">
								{datasetList && datasetList.length > 0 ? (
									// TODO: Sort alphabetically?
									<DatasetContext.Consumer>
										{(context) =>
											datasetList.map((dataset) => (
												<Link
													className={clsx(
														"list-group-item d-flex align-items-center justify-content-between",
														styles.linkContainer
													)}
													key={dataset.id}
													to={{
														pathname: `/organizations/${organizationId}/datasets/${dataset.id}/clients`,
													}}
													onClick={() => context.updateCurrentDataset(dataset)}
												>
													<div className="d-flex flex-column">
														<span className={styles.datasetName}>
															{dataset.name}
														</span>
														<div className="flex flex-row">
															{dataset.datasetPurposeName !== "Production" && (
																<span className={styles.purposeType}>
																	{dataset.datasetPurposeName}
																</span>
															)}
															{dataset.neurapulseProjectId && (
																<img
																	src={neurapulseLogo}
																	alt="Neurapulse Logo"
																	className={styles.neurapulseLogo}
																/>
															)}
														</div>
													</div>
													<Icon icon={ArrowRight} />
												</Link>
											))
										}
									</DatasetContext.Consumer>
								) : (
									<div className="list-item-group">
										<em className="text-muted">No datasets found</em>
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</Page>
		);
	}
}
export default DatasetListView;
